import { keycloak } from "../../../../lib/keycloak";
import { useAppSelector } from "../../../../lib/redux/hooks";
import { groupBy } from "../../../../lib/utils";
import { SelectCustom } from "../../../../ui/molecules/select";

interface Props {
    sectors: string[]
    categories: string[]
    setSectors: (action: string[]) => void
    setCategories: (action: string[]) => void
}

export function AtecosSegment({ sectors, categories, setSectors, setCategories }: Props) {
    const atecosState = useAppSelector(state => state.atecos)

    const sectorsOptions = groupBy(
        atecosState.findAllAtecosResponse,
        "sector"
    ).map((sector) => ({ label: sector.key, value: sector.key }));

    const categoriesOptions = groupBy(
        atecosState.findAllAtecosResponse,
        "category"
    ).map((category) => ({ label: category.key, value: category.key }));

    const handleChangeSectors = (e: string | string[] | undefined) => {
        const _sectors = sectors ?? []
        const e_vector = Array.from(e ?? []);
        if (e_vector && e_vector.length < _sectors.length) {
            const diff = _sectors.find(sector => !e_vector.includes(sector));
            const categoriesToRemove = atecosState.findAllAtecosResponse.filter(category => category.sector === diff).map(category => category.category)
            const newCategories = [...categories.filter(category => !categoriesToRemove.includes(category))];
            setCategories([...newCategories]);
        } else if (e_vector && e_vector.length >= _sectors.length) {
            const added = e_vector.find(sector => !_sectors.includes(sector!));
            const categoriesToAdd = groupBy([...atecosState.findAllAtecosResponse.filter(category => category.sector === added)], 'category').map(category => category.key);
            setCategories([...categories, ...categoriesToAdd]);
        }
        setSectors(Array.from(e ?? []));
    };

    return (
        <div className="grid grid-cols-2 gap-4 w-full">
            <SelectCustom
                isClearable
                placeholder={"Indifferente"}
                options={sectorsOptions}
                isMulti
                disabled={keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
                label="Settore"
                defaultValue={sectors}
                onChange={(e) => {
                    handleChangeSectors(e)
                }}
            />
            <SelectCustom
                isClearable
                placeholder={"Indifferente"}
                options={categoriesOptions}
                label="Categoria"
                disabled={keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
                isMulti
                defaultValue={categories}
                onChange={(e) => setCategories(e ? Array.from(e) : [])}
            />
        </div>
    )
}